export const PRIMARY_COLOR = '#111111';
export const SECONDARY_COLOR = '#D72531';
export const SECONDARY_TEXT_COLOR = '#444';
export const DAY_MILLIS = Math.round(1000 * 60 * 60 * 24);
export const TEMP_AUTH_TOKEN_LOYALTY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiQWNndXcwMSIsImV4cCI6MTc0MzI2NDg5MSwicGFzc3dvcmQiOiJBY0AzMDQwIyJ9.4lixw3FSbyvPL4tXKdroKYRSvWR8C5LeY7xLwC7uQd8';
export const defaultStatuses = [
  {
    status_description: 'Your order is yet to be confirmed',
    status_color: 'primary',
    status_name: 'Pending',
  },
  {
    status_description: 'Your order has been confirmed by IFB',
    status_color: 'primary',
    status_name: 'Confirmed',
  },
  {
    status_description: 'Processing Order',
    status_color: 'primary',
    status_name: 'Ready to dispatch',
  },
  {
    status_description: 'In Transit',
    status_color: 'primary',
    status_name: 'In Transit',
  },
  {
    status_description: 'Out for Delivery',
    status_color: 'primary',
    status_name: 'Out for Delivery',
  },
  {
    status_description: 'Delivered',
    status_color: 'primary',
    status_name: 'Delivered',
  },
];
export const defaultStatusesNames = defaultStatuses.map((status) => status.status_name);
export const LOYALTY_EARN_PERCENT = 0.05;
export const LOYALTY_REDEEM_PERCENT = 0.1;

